import Immutable from 'immutable';

export const State = Immutable.fromJS({
	SIZE: 3,
	firstIndex: 0,
  featuredList: []
});
